export default "__VITE_ASSET__ae490fa1__"